import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import DragHandle from '@components/common/DnD/DragHandle';
import { StyledCard } from '../widgets/styled';
import { CSS } from '@dnd-kit/utilities';

function WidgetCardWrapper({ wid, children, title, style = {}, extra = <></> }) {

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: wid });

  const dndStyle: any = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <StyledCard
      id={wid}
      size="small"
      title={title}
      style={{...dndStyle, ...style}}
      extra={<>{extra}<DragHandle {...attributes} {...listeners} /></>}
      ref={setNodeRef}
    >
      {children}
    </StyledCard>
  );
}

export default WidgetCardWrapper;
